export interface WizardState {
  /** The trailing placeholder slot's in-progress text (only meaningful on the placeholder slot). */
  narrativeInput: string;
  /** Current slot index (0-based) across [...analysed cycles, optional trailing placeholder]. */
  page: number;
  /** Whether a trailing empty placeholder slot exists (fresh start + after "Try again"). */
  placeholderActive: boolean;
  /** True while the accept (selectCycle) mutation is in flight, so the analysing loader stays hidden. */
  accepting: boolean;
}

export const initialWizardState: WizardState = {
  narrativeInput: '',
  page: 0,
  // Fresh start shows a single empty placeholder slot (1/1) ready for the first analysis.
  placeholderActive: true,
  accepting: false,
};

export type WizardAction =
  | { type: 'SET_INPUT'; value: string }
  | { type: 'SET_PAGE'; value: number }
  // Open a fresh empty placeholder at `index` (the slot after the last cycle), optionally pre-filled.
  | { type: 'TRY_AGAIN'; index: number; input?: string }
  // An attempt landed (a new cycle): consume the placeholder and jump to that cycle's slot.
  | { type: 'CYCLE_LANDED'; page: number }
  | { type: 'RESET' }
  | { type: 'START_ACCEPT' }
  | { type: 'END_ACCEPT' };

export const wizardReducer = (state: WizardState, action: WizardAction): WizardState => {
  switch (action.type) {
    case 'SET_INPUT':
      return { ...state, narrativeInput: action.value };
    case 'SET_PAGE':
      return { ...state, page: Math.max(0, action.value) };
    case 'TRY_AGAIN':
      return { ...state, placeholderActive: true, page: action.index, narrativeInput: action.input ?? '' };
    case 'CYCLE_LANDED':
      return { ...state, placeholderActive: false, page: action.page, narrativeInput: '' };
    case 'RESET':
      return { ...initialWizardState };
    case 'START_ACCEPT':
      return { ...state, accepting: true };
    case 'END_ACCEPT':
      return { ...state, accepting: false };
    default:
      return state;
  }
};
